import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import React, { useEffect } from 'react';
import { FilePond, registerPlugin } from 'react-filepond';
import { getTokens } from '../../utils/authStore';
import styles from './FileUpload.module.scss';
import 'filepond/dist/filepond.min.css';
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css';
import type { FileEntry } from '@bp/bp-graphql-types';
import { UploadIcon } from '@bp/ui-components';
import { renderToString } from 'react-dom/server';
import { useTranslation } from 'react-i18next';

// Register the plugins
registerPlugin(FilePondPluginImageExifOrientation, FilePondPluginImagePreview);

type FileUploadProps = {
  onFileUpload?: (file: FileEntry) => void;
};

export const FileUpload = ({ onFileUpload }: FileUploadProps) => {
  const { t } = useTranslation();

  const [token, setToken] = React.useState<string | null>(null);

  useEffect(() => {
    getTokens().then((tokens) => {
      setToken(tokens?.access_token ?? null);
    });
  }, []);

  const label = (
    <div className={`filepond--label-action ${styles['upload-label']}`}>
      <div className={styles.wrapper}>
        <div className={styles.icon}>
          <UploadIcon />
        </div>
        <div className={styles.instruction}>{t('assignment.upload.instruction')}</div>
        <div className={styles.hint}>{t('assignment.upload.hint')}</div>
      </div>
    </div>
  );

  return (
    <FilePond
      className={styles.filepond}
      files={[]}
      allowMultiple={false}
      dropOnPage
      server={{
        process: {
          url: `${import.meta.env.VITE_APP_BACKEND_URI}${import.meta.env.VITE_APP_BACKEND_REST_PATH}/files`,
          headers: {
            Authorization: `Bearer ${token}`,
          },
          ondata: (fd: FormData) => {
            const file = fd.getAll('file');
            if (file[1]) {
              const filename = (file[1] as File).name;
              if (filename) {
                fd.append('filename', filename);
              }
            }
            return fd;
          },
          onload: (response) => {
            const resp = JSON.parse(response);
            if (onFileUpload) onFileUpload(resp);
            return response;
          },
        },
      }}
      name='file' //<-- Muss unbedingt so heissen!
      allowRevert={false}
      labelIdle={renderToString(label)}
      credits={false}
      // acceptedFileTypes={props.fileTypes}
    />
  );
};
